const DetailsModal = ({
  t,
  styles,
  theme,
  isRTL,
  language,
  selectedRequest,
  repaymentHistory,
  getEmployeeName,
  getStatusText,
  getStatusIcon,
  getUrgencyText,
  formatCurrency,
  onClose,
}) => {
  const fmt = (dateStr) =>
    new Date(dateStr).toLocaleDateString(language === "ar" ? "ar-EG" : "en-US");

  return (
    <div style={styles.modal} onClick={onClose}>
      <style>{`
        /* hide scrollbar but keep scrolling */
        .no-scrollbar {
          overflow: auto;
          -ms-overflow-style: none; /* IE and Edge */
          scrollbar-width: none; /* Firefox */
          -webkit-overflow-scrolling: touch; /* iOS smooth scrolling */
        }
        .no-scrollbar::-webkit-scrollbar { display: none; width: 0; height: 0; }
      `}</style>
      <div style={styles.modalContent} className="no-scrollbar" onClick={(e) => e.stopPropagation()}>
        <h3 style={styles.modalTitle}>{t.requestDetails}</h3>

        {/* Details */}
        <div style={{ marginBottom: "24px" }}>
          <div style={styles.detailRow}>
            <span style={styles.detailLabel}>{t.employeeName}:</span>
            <span style={styles.detailValue}>{getEmployeeName(selectedRequest)}</span>
          </div>
          <div style={styles.detailRow}>
            <span style={styles.detailLabel}>{t.employeeCode}:</span>
            <span style={styles.detailValue}>{selectedRequest.infinityCode}</span>
          </div>
          <div style={styles.detailRow}>
            <span style={styles.detailLabel}>{t.requestedAmount}:</span>
            <span style={styles.detailValue}>
              {formatCurrency(selectedRequest.requestedAmount)}
            </span>
          </div>
          <div style={styles.detailRow}>
            <span style={styles.detailLabel}>{t.numberOfInstallments}:</span>
            <span style={styles.detailValue}>
              {selectedRequest.numberOfInstallments || "N/A"}
            </span>
          </div>
          <div style={styles.detailRow}>
            <span style={styles.detailLabel}>{t.installmentAmount}:</span>
            <span style={styles.detailValue}>
              {selectedRequest.installmentAmount
                ? formatCurrency(selectedRequest.installmentAmount)
                : "N/A"}
            </span>
          </div>
          <div style={styles.detailRow}>
            <span style={styles.detailLabel}>{t.totalRepaid}:</span>
            <span style={styles.detailValue}>
              {formatCurrency(selectedRequest.totalRepaid || 0)}
            </span>
          </div>
          <div style={styles.detailRow}>
            <span style={styles.detailLabel}>{t.remainingBalance}:</span>
            <span style={styles.detailValue}>
              {formatCurrency(selectedRequest.remainingBalance || 0)}
            </span>
          </div>
          <div style={styles.detailRow}>
            <span style={styles.detailLabel}>{t.installmentsPaid}:</span>
            <span style={styles.detailValue}>
              {selectedRequest.installmentsPaid || 0} /{" "}
              {selectedRequest.numberOfInstallments || 0}
            </span>
          </div>
          <div style={styles.detailRow}>
            <span style={styles.detailLabel}>{t.reason}:</span>
            <span style={styles.detailValue}>{selectedRequest.reason || "N/A"}</span>
          </div>
          <div style={styles.detailRow}>
            <span style={styles.detailLabel}>{t.urgency}:</span>
            <span style={styles.detailValue}>
              {getUrgencyText(selectedRequest.urgency)}
            </span>
          </div>
          <div style={styles.detailRow}>
            <span style={styles.detailLabel}>{t.status}:</span>
            <span style={styles.statusBadge(selectedRequest.status)}>
              {getStatusIcon(selectedRequest.status)}
              {getStatusText(selectedRequest.status)}
            </span>
          </div>
          <div style={styles.detailRow}>
            <span style={styles.detailLabel}>{t.requestedDate}:</span>
            <span style={styles.detailValue}>
              {fmt(selectedRequest.requestedDate || selectedRequest.created_at)}
            </span>
          </div>
          {selectedRequest.reviewedDate && (
            <div style={styles.detailRow}>
              <span style={styles.detailLabel}>{t.reviewedDate}:</span>
              <span style={styles.detailValue}>{fmt(selectedRequest.reviewedDate)}</span>
            </div>
          )}
          {selectedRequest.reviewerName && (
            <div style={styles.detailRow}>
              <span style={styles.detailLabel}>{t.reviewedBy}:</span>
              <span style={styles.detailValue}>{selectedRequest.reviewerName}</span>
            </div>
          )}
          {selectedRequest.approvalNotes && (
            <div style={styles.detailRow}>
              <span style={styles.detailLabel}>{t.approvalNotes}:</span>
              <span style={styles.detailValue}>{selectedRequest.approvalNotes}</span>
            </div>
          )}
          {selectedRequest.rejectionReason && (
            <div style={styles.detailRow}>
              <span style={styles.detailLabel}>{t.rejectionReason}:</span>
              <span style={styles.detailValue}>{selectedRequest.rejectionReason}</span>
            </div>
          )}
          {selectedRequest.disbursedDate && (
            <div style={styles.detailRow}>
              <span style={styles.detailLabel}>{t.disbursedDate}:</span>
              <span style={styles.detailValue}>{fmt(selectedRequest.disbursedDate)}</span>
            </div>
          )}
          {selectedRequest.disbursementMethod && (
            <div style={styles.detailRow}>
              <span style={styles.detailLabel}>{t.disbursementMethod}:</span>
              <span style={styles.detailValue}>{selectedRequest.disbursementMethod}</span>
            </div>
          )}
          {selectedRequest.referenceNumber && (
            <div style={styles.detailRow}>
              <span style={styles.detailLabel}>{t.referenceNumber}:</span>
              <span style={styles.detailValue}>{selectedRequest.referenceNumber}</span>
            </div>
          )}
          {selectedRequest.repaymentStartDate && (
            <div style={styles.detailRow}>
              <span style={styles.detailLabel}>{t.repaymentStartDate}:</span>
              <span style={styles.detailValue}>
                {fmt(selectedRequest.repaymentStartDate)}
              </span>
            </div>
          )}
          {selectedRequest.nextPaymentDate && (
            <div style={styles.detailRow}>
              <span style={styles.detailLabel}>{t.nextPaymentDate}:</span>
              <span style={styles.detailValue}>
                {fmt(selectedRequest.nextPaymentDate)}
              </span>
            </div>
          )}
        </div>

        {/* Repayment History */}
        {repaymentHistory.length > 0 && (
          <>
            <h4
              style={{
                fontSize: "16px",
                fontWeight: "600",
                marginBottom: "16px",
                color: theme === "light" ? "#0f172a" : "#ffffff",
                textAlign: isRTL ? "right" : "left",
              }}
            >
              {t.repaymentHistory}
            </h4>

            {repaymentHistory.map((payment) => (
              <div
                key={payment.id}
                style={{ ...styles.requestCard, marginBottom: "12px", padding: "16px" }}
              >
                <div style={styles.detailRow}>
                  <span style={styles.detailLabel}>
                    {t.installmentNum} {payment.installmentNumber}
                  </span>
                  <span style={styles.detailValue}>
                    {formatCurrency(payment.amount)}
                  </span>
                </div>
                <div style={styles.detailRow}>
                  <span style={styles.detailLabel}>{t.paymentDate}:</span>
                  <span style={styles.detailValue}>{fmt(payment.paymentDate)}</span>
                </div>
                <div style={styles.detailRow}>
                  <span style={styles.detailLabel}>{t.method}:</span>
                  <span style={styles.detailValue}>
                    {payment.paymentMethod || "N/A"}
                  </span>
                </div>
                {payment.referenceNumber && (
                  <div style={styles.detailRow}>
                    <span style={styles.detailLabel}>{t.reference}:</span>
                    <span style={styles.detailValue}>{payment.referenceNumber}</span>
                  </div>
                )}
                {payment.notes && (
                  <div style={styles.detailRow}>
                    <span style={styles.detailLabel}>{t.notes}:</span>
                    <span style={styles.detailValue}>{payment.notes}</span>
                  </div>
                )}
              </div>
            ))}
          </>
        )}

        {/* Close */}
        <div
          style={{
            ...styles.buttonGroup,
            justifyContent: isRTL ? "flex-start" : "flex-end",
            marginTop: "24px",
          }}
        >
          <button style={styles.secondaryButton} onClick={onClose}>
            {t.close}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DetailsModal;